<template>
  <div :class="{'player' : true, 'enter' : video}">
    <transition name="display">
      <div v-if="video != '' && isNaN(video) " class="vid">
        <router-link class="fecha" :to="{ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: $route.params.obra} }">&#215;</router-link>
        <youtube ref="youtube" :video-id="video" :player-vars="playerVars" @ended="$router.push({ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: $route.params.obra} })"></youtube>
      </div>
      <div v-else-if="video != ''" class="vid">
        <router-link class="fecha" :to="{ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: $route.params.obra} }">&#215;</router-link>
        <vimeo-player ref="player" :video-id="video" :options="options" @ended="$router.push({ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: $route.params.obra} })"></vimeo-player>
      </div>
    </transition>
  </div>
</template>

<script>
import works from '@/static/projetos.js'

export default {
  name: 'Player',
  data() {
    return {
      options: { color: 'fff', autoplay: true, title: false, byline: false, controls: true },
      playerVars: {autoplay: 1, modestbranding: 1, showinfo: 0},
    }
  },
  computed: {
    video() { return this.$route.params.video}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.player {
  position: absolute; z-index: 99;
  top: 200vh; right: 130vw;
  width: 100vw; height: 100vh;
  transition: all .5s ease-in-out;
  padding: 2vh 20px;
}
.player.enter {right: 0;}

.vid {
  width: 100%; height: 100%;
  background-color: #fff;
  padding: 10px;
  border: 8px solid #d55349;
  display: flex;
  align-items: center;
}
.vid >>> iframe {width: 100%; height: 100%;}
.vid .fecha {top: 0; right: 0;}

.fecha {
  position: absolute;
  z-index: 99;
  width: 40px; height: 40px;
  top: -30px; right: -30px;
  background-color: #fff;
  border-radius: 50%;
  border: 6px solid #d55349;
  display: flex;
  align-items: center; justify-content: space-around;
  font-size: x-large; font-weight: 800; color: #d55349;
}

.fade >>> h1 {opacity: 0;}
.display-enter-active, .display-leave-active { transition: opacity .5s ease-in-out; }
.display-enter, .display-leave-to { opacity: 0; }
/* -- SETA -- */
.scroll-left {
  position: absolute;
  display: block;
  left: 0; top: 50%;
  width: 20px;
  height: 30px;
  transform: translateY(-50%);
  padding-top: 11.5px;
}
.arrow-left {
  display: block;
  margin: 0 0 -5px -6px;
}
.arrow-left::before {
  content: '';
  display: block;
  margin: auto;
  padding: 0;
  width: 5px;
  height: 5px;
  border-top: 2px solid #d55349;
  border-right: 2px solid #d55349;
  transform: rotate(225deg);
}
.scroll-left::after {
  animation: elasticus 2s cubic-bezier(1, 0, 0, 1) reverse infinite;
  display: block;
  margin-left: 2px;
  height: 2px;
  width: 15px;
  background: #d55349;
  content: ' ';
}

/* SETA */
@keyframes elasticus {
  0% {
    transform-origin: 0% 0%;
    transform: scale(0, 1);
  }
  50% {
    transform-origin: 0% 0%;
    transform: scale(1, 1);
  }
  50.1% {
    transform-origin: 100% 0%;
    transform: scale(1, 1);
  }
  100% {
    transform-origin: 100% 0%;
    transform: scale(0, 1);
  }
}

/* -- PADROES -- */
.tamanho1, .tamanho2
{ grid-template-columns: 1fr }

.tamanho3, .tamanho4
{ grid-template-columns: repeat(2, 1fr)}

.tamanho5, .tamanho7, .tamanho9
{ grid-template-columns: repeat(3, 1fr)}

.tamanho6, .tamanho8, .tamanho15
{grid-template-columns: repeat(5, 1fr)}

.tamanho10, .tamanho11
{grid-template-columns: repeat(4, 1fr)}

.tamanho3 .trabalho,
.tamanho5 .trabalho,
.tamanho7 .trabalho,
.tamanho9 .trabalho:nth-child(2n), .tamanho9 .trabalho:nth-child(5),
.tamanho10 .trabalho,
.tamanho11 .trabalho:nth-child(3n), .tamanho11 .trabalho:nth-child(3n+2),
.tamanho12 .trabalho,
.tamanho14 .trabalho:nth-child(7n+2), .tamanho14 .trabalho:nth-child(7n+4), .tamanho14 .trabalho:nth-child(7n+5), .tamanho14 .trabalho:nth-child(7n+6),
.tamanho15 .trabalho:nth-child(2), .tamanho15 .trabalho:nth-child(4), .tamanho15 .trabalho:nth-child(5), .tamanho15 .trabalho:nth-child(8), .tamanho15 .trabalho:nth-child(9), .tamanho15 .trabalho:nth-child(11), .tamanho15 .trabalho:nth-child(13)
{ grid-area: span 2 / span 1; }

.tamanho3 .trabalho:nth-child(3),
.tamanho8 .trabalho,
.tamanho9 .trabalho:nth-child(1), .tamanho9 .trabalho:nth-child(8),
.tamanho10 .trabalho:nth-child(3n), .tamanho10 .trabalho:nth-child(10n),
.tamanho11 .trabalho:nth-child(1), .tamanho11 .trabalho:nth-child(n+9),
.tamanho12 .trabalho:nth-child(3n),
.tamanho13 .trabalho:nth-child(4n+1),
.tamanho14 .trabalho:nth-child(1), .tamanho14 .trabalho:nth-child(10),
.tamanho15 .trabalho
{ grid-area: span 1 / span 2; }

.tamanho4 .trabalho:nth-child(1), .tamanho4 .trabalho:nth-child(2)
{ grid-area: span 3 / span 1; }

.tamanho5 .trabalho:nth-child(5n+1), .tamanho5 .trabalho:nth-child(5n),
.tamanho6 .trabalho,
.tamanho8 .trabalho:nth-child(4n), .tamanho8 .trabalho:nth-child(4n+1)
{ grid-area: span 1 / span 3; }

.tamanho4 .trabalho,
.tamanho6 .trabalho:nth-child(4n+1),
.tamanho7 .trabalho:nth-child(6n+1)
{ grid-area: span 2 / span 2; }

.tamanho11 .trabalho:nth-child(10), .tamanho11 .trabalho:nth-child(11),
.tamanho13 .trabalho:nth-child(9)
{ grid-area: span 1 / span 1; }



/* --- LETREIRO --- */
  .cinema h1 >>> span, .midias h1 >>> span, .producao h1 >>> span, {
    animation: none;
  }
    /* CINEMA */
    .cinema h1 >>> span:nth-child(1) { /* C */
      	grid-column: 2;
      	grid-row: 1;
      }
    .cinema h1 >>> span:nth-child(2) { /* i */
      	grid-column: 1;
      	grid-row: 2;
      }
    .cinema h1 >>> span:nth-child(3) { /* n */
      	grid-column: 8;
      	grid-row: 4;
      }
    .cinema h1 >>> span:nth-child(4) { /* e */
      	grid-column: 8;
      	grid-row: 5;
      }
    .cinema h1 >>> span:nth-child(5) { /* m */
      	grid-column: 1;
      	grid-row: 7;
      }
    .cinema h1 >>> span:nth-child(6) { /* a */
      	grid-column: 6;
      	grid-row: 8;
      }
    /* NOVAS MIDIAS */
      .midias h1 >>> span:nth-child(1) { /* N */
      	grid-column: 3;
      	grid-row: 1;
      }
      .midias h1 >>> span:nth-child(2) { /* o */
      	grid-column: 4;
      	grid-row: 1;
      }
      .midias h1 >>> span:nth-child(3) { /* v */
      	grid-column: 7;
      	grid-row: 1;
      }
      .midias h1 >>> span:nth-child(4) { /* a */
      	grid-column: 1;
      	grid-row: 2;
      }
      .midias h1 >>> span:nth-child(5) { /* s */
      	grid-column: 1;
      	grid-row: 3;
      }
      .midias h1 >>> span:nth-child(6) { /* M */
      	grid-column: 8;
      	grid-row: 5;
      }
      .midias h1 >>> span:nth-child(7) { /* í */
      	grid-column: 8;
      	grid-row: 6;
      }
      .midias h1 >>> span:nth-child(8) { /* d */
      	grid-column: 1;
      	grid-row: 7;
      }
      .midias h1 >>> span:nth-child(9) { /* i */
      	grid-column: 3;
      	grid-row: 8;
      }
      .midias h1 >>> span:nth-child(10) { /* a */
      	grid-column: 7;
      	grid-row: 8;
      }
      .midias h1 >>> span:nth-child(11) { /* s */
      	grid-column: 8;
      	grid-row: 8;
      }
    /* PRODUÇÃO CULTURAL */
      .producao h1 >>> span:nth-child(1) { /* P */
      	grid-column: 1;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(2) { /* r */
      	grid-column: 2;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(3) { /* o */
      	grid-column: 3;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(4) { /* d */
      	grid-column: 6;
      	grid-row: 1;
      }
      .producao h1 >>> span:nth-child(5) { /* u */
      	grid-column: 8;
      	grid-row: 2;
      }
      .producao h1 >>> span:nth-child(6) { /* ç */
      	grid-column: 1;
      	grid-row: 3;
      }
      .producao h1 >>> span:nth-child(7) { /* ã */
      	grid-column: 1;
      	grid-row: 4;
      }
      .producao h1 >>> span:nth-child(8) { /* o */
      	grid-column: 1;
      	grid-row: 5;
      }
      .producao h1 >>> span:nth-child(9) { /* C */
      	grid-column: 8;
      	grid-row: 4;
      }
      .producao h1 >>> span:nth-child(10) { /* u */
      	grid-column: 8;
      	grid-row: 5;
      }
      .producao h1 >>> span:nth-child(11) { /* l */
      	grid-column: 8;
      	grid-row: 6;
      }
      .producao h1 >>> span:nth-child(12) { /* t */
      	grid-column: 1;
      	grid-row: 7;
      }
      .producao h1 >>> span:nth-child(13) { /* u */
      	grid-column: 2;
      	grid-row: 8;
      }
      .producao h1 >>> span:nth-child(14) { /* r */
      	grid-column: 5;
      	grid-row: 8;
      }
      .producao h1 >>> span:nth-child(15) { /* a */
      	grid-column: 6;
      	grid-row: 8;
      }
      .producao h1 >>> span:nth-child(16) { /* l */
      	grid-column: 8;
      	grid-row: 8;
      }


/* --- ADAPTIVE LAYOUT -- */

@media (orientation: portrait) {
  section{grid-template-columns: repeat(7, 1fr);}
}

@media (min-width: 768px) {
  .videos {display: none;}
}
</style>
